<template>
  <div v-if="chatReady" class="chat-wrapper">
    <div
      :id="'vue-chat-' + key"
      v-if="chatAccessError == null"
      :class="chatFull ? 'vue-chat vue-chat--full' : 'vue-chat'"
    >
      <chatHeader :unread-count="unreadMessagesCountSeparator" />
      <div v-if="chatError.length > 0" class="chat-error">{{ chatError }}</div>
      <div v-bar ref="scrollWrap" class="scroll-wrap">
        <div>
          <div v-if="messages.length > 0" class="messages">
            <message
              v-for="(message, index) in messages"
              :key="index"
              :ref="'message' + index"
              :users="users"
              :message="message"
              :access-level="accessLevel"
              :unread-messages-count="unreadMessagesCountSeparator"
              :index="index"
              :delete-message="deleteMessage"
              :index-first-unread-message="indexFirstUnreadMessage"
              class="message"
            />

            <div v-if="chatTypingStatus" class="chat-typing">
              <div v-for="(user, index) in users" :key="index">
                <span v-if="user.typing"
                  >{{ user.userName }}
                  {{ translate("chat", "набирает сообщение", {}) }}</span
                >
              </div>
            </div>
          </div>
          <template v-else>
            <noMessage />
          </template>
        </div>
      </div>
      <sendMessage
        v-if="!chatClosed && messagesDisabled != 1"
        :main-user="mainUser"
        :order-id="key"
        :send-message="sendMessage"
      />
      <div v-else class="chat-closed">
        <strong>{{
          translate("chat", "Работа над заказом окончена", {})
        }}</strong>
        {{ translate("chat", "Чат больше недоступен", {}) }}
      </div>
    </div>
    <div
      v-if="chatAccessError == 1"
      :class="[
        chatFull ? 'vue-chat--full' : '',
        'vue-chat vue-chat--error vue-chat--pin-error',
      ]"
    >
      <chatHeader :unread-count="unreadMessagesCount" />
      <i class="icon-access-problem"></i>
      <strong>{{ translate("chat", "Введите пин-код", {}) }}</strong>
      <p>
        {{
          translate("chat", "Введите пин-код, чтобы получить доступ к чату", {})
        }}
      </p>
      <p class="vue-chat-get-success">
        <a @click="openPinCodeModal">{{
          translate("chat", "Ввести пин-код", {})
        }}</a>
      </p>
    </div>
    <div
      v-if="chatAccessError == 3"
      :class="[
        chatFull ? 'vue-chat--full' : '',
        'vue-chat vue-chat--error vue-chat--need-auth',
      ]"
    >
      <chatHeader :unread-count="unreadMessagesCount" />
      <i class="icon-need-auth"></i>
      <strong>{{ translate("chat", "Необходима авторизация", {}) }}</strong>
      <p>
        {{
          translate(
            "chat",
            "Вам нужно войти или зарегистрироваться, чтобы получить доступ к чату",
            {}
          )
        }}
      </p>
      <p class="vue-chat-get-success">
        <a @click="login">
          {{ translate("chat", "Войти / Зарегистироваться", {}) }}</a
        >
      </p>
    </div>
    <div
      v-if="chatAccessError == 2 || chatAccessError == 5"
      :class="[
        chatFull ? 'vue-chat--full' : '',
        'vue-chat vue-chat--error vue-chat--problem',
      ]"
    >
      <chatHeader :unread-count="unreadMessagesCount" />
      <i class="icon-access-problem"></i>
      <strong>{{ translate("chat", "Нет доступа к чату", {}) }}</strong>
      <p>
        {{
          translate(
            "chat",
            "У Вас нет доступа к этому чату, если Вы считаете, что это ошибка, то свяжитесь с нашей службой поддержки",
            {}
          )
        }}
      </p>
      <p class="vue-chat-get-success">
        <a :href="'/' + URI_LANGUAGE + '/support'" target="_blank">{{
          translate("chat", "Связаться", {})
        }}</a>
      </p>
    </div>
    <div v-if="!chatFull" class="open-chat" @click="chatFull = true">
      {{ translate("chat", "Открыть чат", {}) }}
    </div>
  </div>
</template>

<script>
import store from "../../store/store";

import noMessage from "../../components/chat/noMessage.vue";
import chatHeader from "../../components/chat/chatHeader.vue";
import message from "../../components/chat/message.vue";
import sendMessage from "../../components/chat/sendMessage.vue";
import Vuebar from "vuebar";
import Vue from "vue";
Vue.use(Vuebar);
function throttle(callback, limit) {
  let wait = false;
  return function() {
    if (!wait) {
      wait = true;
      setTimeout(function() {
        wait = false;
        callback.call();
      }, limit);
    }
  };
}
function dateFormatChat(unixTime) {
  let date = new Date(unixTime * 1000);
  let dateFormat = "";
  let dateNow = new Date(parseInt(Date.now()));
  let hour = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
  let min =
    date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();

  // Check today or not today
  if (date.toDateString() === dateNow.toDateString()) {
    dateFormat = hour + ":" + min;
  } else {
    dateFormat =
      date.getDate() +
      " " +
      date.toLocaleString("ru", { month: "short" }) +
      " " +
      hour +
      ":" +
      min;
  }
  return dateFormat;
}
function fullDate(unixTime) {
  let date = new Date(unixTime * 1000);
  return date;
}
export default {
  name: "chat",
  components: {
    noMessage,
    chatHeader,
    message,
    sendMessage,
  },
  store,
  data: function() {
    return {
      messages: [],
      newMessageSound: new Audio(require("../../sounds/message.wav")),
      indexFirstUnreadMessage: null,
      key: undefined,
      orderPin: undefined,
      userId: undefined,
      messagesDisabled: null,
      accessLevel: null,
      users: {},
      usersOnline: [],
      mainUser: {
        userId: null,
        userName: null,
        userPhoto: null,
      },
      readMessagesIds: [],
      readMessagesIndexes: [],
      windowActive: true,
      chatToken: null,
      chatFull: false,
      chatAccessError: null,
      chatError: "",
      chatClosed: false,
      chatReady: false,
      countAccessRequest: 0,
      unreadMessagesCountSeparator: 0,
      chatType: 1,
      isIdle: false,
    };
  },
  computed: {
    unreadMessagesCount: function() {
      var count = 0;
      for (let i = 0; i < this.messages.length; i++) {
        if (this.accessLevel == this.messages[i].role) {
          continue;
        }
        if (
          this.accessLevel == "admin" &&
          this.messages[i].is_admin_read == 0
        ) {
          count++;
        }
        if (
          this.accessLevel == "booster" &&
          this.messages[i].is_booster_read == 0
        ) {
          count++;
        }
        if (this.accessLevel == "user" && this.messages[i].is_user_read == 0) {
          count++;
        }
      }

      return count;
    },
    chatTypingStatus: function() {
      let status = false;
      for (let id in this.users) {
        if (this.users[id].typing) {
          status = true;
        }
      }
      return status;
    },
  },
  watch: {
    chatFull: function() {
      if (this.chatFull && this.chatAccessError == null)
        this.messagesAreaOptions();
    },
    windowActive: function() {
      if (this.windowActive && this.chatFull) this.readVisibleMessages();
    },
  },
  created: function() {
    document.addEventListener("login", () => {
      this.chatReady = false;
      this.chatFull = false;
      this.connectToChat();
    });

    this.throttleReadMessages = throttle(() => {
      let scrollWrap = this.$refs.scrollWrap;
      let scrollArea = scrollWrap.getElementsByClassName("vb-content")[0];
      let messagesArray = [...scrollWrap.getElementsByClassName("message")];
      let bottomOfScroll = scrollArea.scrollTop + scrollArea.offsetHeight;
      let readMessagesIds = [];
      let firstUnreadMessage;
      if (this.indexFirstUnreadMessage != null && this.windowActive) {
        firstUnreadMessage = scrollWrap.getElementsByClassName("message")[
          this.indexFirstUnreadMessage - 1
        ];
        if (
          bottomOfScroll >
          firstUnreadMessage.offsetTop + firstUnreadMessage.offsetHeight - 20
        ) {
          for (let i = 0; i < messagesArray.length; i++) {
            let messageEndPosition =
              messagesArray[i].offsetTop + messagesArray[i].offsetHeight;
            if (messageEndPosition <= bottomOfScroll) {
              if (this.accessLevel == "admin") {
                if (this.messages[i].is_admin_read == 1) {
                  continue;
                } else {
                  this.messages[i].is_admin_read = 1;
                  readMessagesIds.push(this.messages[i].id);
                }
              }
              if (this.accessLevel == "user") {
                if (this.messages[i].is_user_read == 1) {
                  continue;
                } else {
                  this.messages[i].is_user_read = 1;
                  readMessagesIds.push(this.messages[i].id);
                }
              }
              if (this.accessLevel == "booster") {
                if (this.messages[i].is_booster_read == 1) {
                  continue;
                } else {
                  this.messages[i].is_booster_read = 1;
                  readMessagesIds.push(this.messages[i].id);
                }
              }
            } else {
              if (i > this.indexFirstUnreadMessage) {
                this.indexFirstUnreadMessage = i - 1;
              } else if (i == this.indexFirstUnreadMessage) {
                this.indexFirstUnreadMessage = null;
              }
            }
          }
          if (readMessagesIds.length > 0) {
            this.readMessages(readMessagesIds);
          }
        }
      }
    }, 2000);
  },
  async mounted() {
    this.connectToChat();

    // Подключаем опции сокета
    this.socketOptions();
    this.idle();

    setInterval(async () => {
      if (socket.connected) {
        this.chatError = "";
      } else {
        if (this.isIdle) {
          this.chatError = translate(
            "chat",
            "Нет соединения с сервером. Обновления в режиме реального времени недоступны",
            {}
          );
        } else {
          this.chatError = translate(
            "chat",
            "Нет соединения с сервером. Обновления в режиме реального времени недоступны. Чат будет обновляться каждые 5 секунд",
            {}
          );

          const messages = await this.getChatMessages(this.key, this.orderPin);
          this.messages = messages ? messages : [];
        }
      }
    }, 5000);
  },
  methods: {
    idle: function() {
      let events = ["touch", "mousemove", "keypress"];
      let wait = 0;
      let duration = 60;
      let timer;

      document.addEventListener("visibilitychange", function() {
        if (document.visibilityState === "visible") {
          this.isIdle = false;
        }
      });

      setTimeout(() => {
        setTimer();

        for (let i = events.length - 1; i >= 0; i -= 1) {
          window.addEventListener(events[i], clearTimer);
        }
      }, wait * 1000);

      const setIdle = () => {
        this.isIdle = true;
      }

      const setTimer = () => {
        timer = window.setInterval(setIdle, duration * 1000);
      }

      const clearTimer = () => {
        this.isIdle = false;
        clearInterval(timer);
        setTimer();
      }
    },
    connectToChat: async function() {
      if (this.$parent.$options.customElement.attributes) {
        if (this.$parent.$options.customElement.attributes["data-key"]) {
          this.key = parseInt(
            this.$parent.$options.customElement.attributes["data-key"].value
          );
        }

        if (this.$parent.$options.customElement.attributes["data-user-id"]) {
          this.userId = parseInt(
            this.$parent.$options.customElement.attributes["data-user-id"].value
          );
        }

        if (this.$parent.$options.customElement.attributes["data-chat-type"]) {
          this.chatType = parseInt(
            this.$parent.$options.customElement.attributes["data-chat-type"]
              .value
          );
        }

        if (
          this.$parent.$options.customElement.attributes[
            "data-new-message-disable"
          ]
        ) {
          this.messagesDisabled = parseInt(
            this.$parent.$options.customElement.attributes[
              "data-new-message-disable"
            ].value
          );
        }

        if (this.$parent.$options.customElement.attributes["data-order-pin"]) {
          this.orderPin = this.$parent.$options.customElement.attributes[
            "data-order-pin"
          ].value;
        }
      }

      if (!this.userId || this.userId == "") {
        this.userId = parseInt(
          document
            .querySelectorAll("meta[name=userId]")[0]
            .getAttribute("content")
        );
      }
      let checkChatAccess = this.checkChatStatus(
        this.key,
        this.orderPin,
        this.userId
      );

      let chatAccess = await checkChatAccess;
      if (chatAccess.success) {
        this.accessLevel = chatAccess.role;

        // Если есть доступ к чату подключаемся к нему
        let chatInfo = {};
        chatInfo.type = this.chatType;
        chatInfo.chatToken = chatAccess.chatToken;
        chatInfo.key = this.key;
        chatInfo.userId = this.userId;
        chatInfo.chatTtl = chatAccess.chatTtl;
        this.chatToken = chatAccess.chatToken;

        this.joinChat(chatInfo);

        let getMessages = this.getChatMessages(this.key, this.orderPin);

        this.messages = await getMessages;

        if (!this.messages) {
          this.messages = [];
        }

        if (this.chatType == 1 && this.accessLevel == "user") {
          this.messages.unshift({
            created_at: new Date().getTime(),
            id:
              this.messages.length > 0
                ? parseInt(this.messages[this.messages.length - 1].id) + 1
                : 999999,
            is_admin_read: 1,
            is_booster_read: 1,
            is_deleted: 0,
            is_user_read: 1,
            key: 0,
            message: this.translate(
              "chat",
              '"Сделки вне сайта небезопасны и несут риск мошенничества. Для вас нет никаких гарантий и вы не сможете вернуть деньги в случае неоказания вам услуг."',
              {}
            ),
            photo: "/img/anylvlbot.svg",
            role: "bot",
            type: 0,
            user_id: 999999,
            username: "Anylvl bot",
          });
        }

        // Расставляем статусы юзеров
        for (let i = 0; i < this.usersOnline.length; i++) {
          let userId = this.usersOnline[i];
          if (!this.users[userId]) continue;
          this.users[userId].online = true;
        }
        this.unreadMessagesCountSeparator = this.unreadMessagesCount;
        if (this.unreadMessagesCountSeparator > 0) {
          if (
            $(
              "#offer-" +
                this.key +
                " .open-offer-card-button .unreaded-messages"
            )
          ) {
            $(
              "#offer-" +
                this.key +
                " .open-offer-card-button .unreaded-messages"
            ).text(this.unreadMessagesCountSeparator);
            $(
              "#offer-" +
                this.key +
                " .open-offer-card-button .unreaded-messages"
            ).show();
          }
        } else {
          if (
            $(
              "#offer-" +
                this.key +
                " .open-offer-card-button .unreaded-messages"
            )
          ) {
            $(
              "#offer-" +
                this.key +
                " .open-offer-card-button .unreaded-messages"
            ).text(0);
            $(
              "#offer-" +
                this.key +
                " .open-offer-card-button .unreaded-messages"
            ).hide();
          }
        }
      }
    },
    messagesAreaOptions: function() {
      // Определяем активность вкладки
      window.addEventListener(
        "focus",
        () => {
          this.windowActive = true;
        },
        false
      );
      window.addEventListener(
        "blur",
        () => {
          this.windowActive = false;
        },
        false
      );
      // Поле в которое попадают сообщения
      let scrollWrap = this.$refs.scrollWrap;
      let scrollArea = scrollWrap.getElementsByClassName("vb-content")[0];
      let messagesArea = scrollWrap.getElementsByClassName("messages")[0];

      // Читка сообщений по скроллу
      scrollArea.addEventListener("scroll", () => {
        this.throttleReadMessages();
      });

      // Если все сообщения прочитаны скролим в конец
      if (this.indexFirstUnreadMessage == null) {
        this.scrollToMessage(this.messages.length - 1);
      }
      // Иначе скролим к первому непрочитанному сообщению
      else {
        this.scrollToMessage(this.indexFirstUnreadMessage);
      }

      // Читаем непрочитанные сообщения которые попали в область видимости
      let readMessagesIds = [];
      if (
        this.messages.length > 0 &&
        messagesArea.offsetHeight < scrollArea.offsetHeight
      ) {
        for (let i = 0; i < this.messages.length; i++) {
          readMessagesIds.push(this.messages[i].id);
        }
        this.readMessages(readMessagesIds);
      }
    },
    scrollToMessage: function(index) {
      if (index < 0) return;
      let scrollWrap = this.$refs.scrollWrap;
      let scrollArea = scrollWrap.getElementsByClassName("vb-content")[0];
      let message;
      message = scrollWrap.getElementsByClassName("message")[index];
      scrollArea.scrollTop = message.offsetTop - 20;
    },
    sendMessage: function(text) {
      let message = {};
      message.created_at = dateFormatChat(Date.now() / 1000);
      message.dateFull = fullDate(Date.now() / 1000);
      message.message = text;
      message.id = Math.floor(Math.random());
      message.photo = this.mainUser.userPhoto;
      message.username = this.mainUser.userName;
      message.role = this.accessLevel;
      message.order_id = this.key;
      message.user_id = this.mainUser.userId;
      message.is_deleted = 0;
      if (this.accessLevel == "admin") {
        message.is_admin_read = 1;
      }
      if (this.accessLevel == "user") {
        message.is_user_read = 1;
      }
      if (this.accessLevel == "booster") {
        message.is_booster_read = 1;
      }
      this.indexFirstUnreadMessage = null;
      this.messages.push(message);
      this.$nextTick(() => {
        this.scrollToMessage(this.messages.length - 1);
      });
      $.ajax({
        type: "POST",
        url: "/" + URI_LANGUAGE + "/frontend/chat/post-message",
        data: {
          type: this.chatType,
          key: this.key,
          pin: this.pin,
          message: text,
        },
        dataType: "json",
        success: (data) => {},
        error: (data) => {
          this.chatError = this.translate(
            "chat",
            'Не удалось отправить сообщение: "' + text + '"',
            {}
          );
          this.messages.find((element) => {
            if (element.id == message.id) {
              element.is_deleted = 1;
            }
          });
          setTimeout(() => {
            this.chatError = "";
          }, 3000);
        },
      });
    },

    readVisibleMessages: function() {
      // Поле в которое попадают сообщения
      if (this.indexFirstUnreadMessage == null) return;
      let scrollWrap = this.$refs.scrollWrap;
      let scrollArea = scrollWrap.getElementsByClassName("vb-content")[0];
      let bottomOfScroll = scrollArea.scrollTop + scrollArea.offsetHeight;
      // Читаем непрочитанные сообщения которые попали в область видимости
      let readMessagesIds = [];
      let firstUnreadMessage;
      for (
        let i = this.indexFirstUnreadMessage;
        i < this.messages.length;
        i++
      ) {
        firstUnreadMessage = scrollWrap.getElementsByClassName("message")[
          this.indexFirstUnreadMessage
        ];
        if (
          bottomOfScroll >
          firstUnreadMessage.offsetTop + firstUnreadMessage.offsetHeight - 20
        ) {
          readMessagesIds.push(this.messages[i].id);
          this.indexFirstUnreadMessage++;
        } else {
          break;
        }
      }
      this.readMessages(readMessagesIds);
    },
    readMessages: function(messagesId) {
      if (messagesId.length == 0) return;
      $.ajax({
        type: "POST",
        url: "/" + URI_LANGUAGE + "/frontend/chat/read-messages",
        data: {
          messagesIds: messagesId,
          chatToken: this.chatToken,
          key: this.key,
          type: this.chatType,
        },
        dataType: "json",
        success: (data) => {
          this.indexFirstUnreadMessage = null;
          this.unreadMessagesCountSeparator = 0;
          if (
            $(
              "#offer-" +
                this.key +
                " .open-offer-card-button .unreaded-messages"
            )
          ) {
            $(
              "#offer-" +
                this.key +
                " .open-offer-card-button .unreaded-messages"
            ).val(0);
            $(
              "#offer-" +
                this.key +
                " .open-offer-card-button .unreaded-messages"
            ).hide();
          }
        },
      });
    },

    deleteMessage: function(messageId) {
      $.ajax({
        type: "POST",
        url: "/" + URI_LANGUAGE + "/frontend/chat/delete-message",
        data: {
          messageId: messageId,
          key: this.key,
          type: this.chatType,
        },
        dataType: "json",
      });
    },

    getChatMessages: async function(key, orderPin) {
      return new Promise((resolve, reject) => {
        $.ajax({
          type: "GET",
          url: "/" + URI_LANGUAGE + "/frontend/chat/get-messages",
          data: { type: this.chatType, key: key, pin: orderPin },
          dataType: "json",
          success: (data) => {
            if (data.success) {
              this.chatReady = true;
              let messages = data.messages;
              for (let i = 0; i < messages.length; i++) {
                messages[i].dateFull = fullDate(messages[i].created_at);
                messages[i].created_at = dateFormatChat(messages[i].created_at);

                // Делаем список пользователей
                let userId = messages[i].user_id;
                if (!this.users[userId]) {
                  this.$set(this.users, userId, {
                    online: false,
                    typing: false,
                    userName: messages[i].username,
                    timeOut: null,
                  });
                }

                // Вычисляем первое непрочитанное сообщение
                if (this.indexFirstUnreadMessage == null) {
                  if (this.accessLevel == messages[i].role) {
                    continue;
                  }
                  if (
                    this.accessLevel == "admin" &&
                    messages[i].is_admin_read == 0
                  ) {
                    this.indexFirstUnreadMessage = i;
                  }
                  if (
                    this.accessLevel == "user" &&
                    messages[i].is_user_read == 0
                  ) {
                    this.indexFirstUnreadMessage = i;
                  }
                  if (
                    this.accessLevel == "booster" &&
                    messages[i].is_booster_read == 0
                  ) {
                    this.indexFirstUnreadMessage = i;
                  }
                }
              }
              resolve(messages);
            } else {
              reject("error to get messages");
            }
          },
          error: function(error) {
            reject(error);
          },
        });
      });
    },

    checkChatStatus: async function(key, orderPin) {
      return new Promise((resolve, reject) => {
        this.countAccessRequest++;
        if (this.countAccessRequest > 5) {
          let data = {};
          data.success = false;
          this.chatError = this.translate(
            "chat",
            "Ошибка подключения к чату. Попробуйте перезагрузить страницу",
            {}
          );
          resolve(data);
        }
        $.ajax({
          type: "POST",
          url: "/" + URI_LANGUAGE + "/frontend/chat/check-access",
          data: {
            type: this.chatType,
            key: key,
            pin: orderPin ? orderPin : "",
          },
          dataType: "json",
          success: (data) => {
            if (data.success) {
              this.chatAccessError = null;
              this.$set(this.users, data.userId, {
                online: false,
                typing: false,
                userName: data.userLogin,
                timeOut: null,
              });
              this.mainUser.userId = data.userId;
              this.mainUser.userName = data.userLogin;
              this.mainUser.userPhoto = data.userPhoto;
              if (data.orderStatus == 5) this.chatClosed = true;
              resolve(data);
            } else {
              reject(data);
            }
          },
          error: (error) => {
            let dataError = error.responseJSON;
            this.chatAccessError = dataError.code;
            this.chatReady = true;
            reject(dataError);
          },
        });
      });
    },

    joinChat: async function(data) {
      return new Promise((resolve, reject) => {
        socket.emit(
          "chat join",
          {
            chatType: data.type,
            key: data.key,
            chatToken: data.chatToken,
            userId: data.userId,
            chatTtl: data.chatTtl,
          },
          (data) => {
            if (data.usersOnline) {
              this.usersOnline = data.usersOnline;
              resolve(true);
            } else {
              this.chatError = this.translate(
                "chat",
                "Не удалось подключится к чату",
                {}
              );
              reject(data);
            }
          }
        );
      });
    },
    socketOptions: function() {
      socket.on("disconnect", (data) => {
        this.connectToChat();
      });
      socket.on("chat online", (data) => {
        this.onUserConnect(data.userId);
      });
      socket.on("chat offline", (data) => {
        this.onUserDisconnect(data.userId);
      });
      socket.on("chat message", (data) => {
        this.onGetMessage(data);
      });
      socket.on("chat typing", (data) => {
        this.chatTyping(data);
      });
      socket.on("order status", (data) => {
        this.onChangeOrderStatus(data);
      });
      socket.on("delete message", (data) => {
        this.onDeleteMessage(data.messageId);
      });
      socket.on("chat leave", (data) => {
        if (data.type == 1 && data.key == this.key) {
          this.chatFull = false;
          this.connectToChat();
        }
      });
    },
    onChangeOrderStatus: function(payload) {
      if (parseInt(payload.status) === 5 && payload.order_id == this.key)
        this.chatClosed = true;
    },
    onDeleteMessage: function(messageId) {
      for (let i = 0; i < this.messages.length; i++) {
        if (this.messages[i].id == messageId) this.messages[i].is_deleted = 1;
      }
    },
    onUserConnect: function(userId) {
      if (!this.users[userId]) return;
      this.users[userId].online = true;
    },
    onUserDisconnect: function(userId) {
      if (!this.users[userId]) return;
      this.users[userId].online = false;
    },
    chatTyping: function(data) {
      let userId = data.userId;
      let userName = data.username;

      if (data.key != this.key) return;
      if (userId == this.userId) return; // Если печатаю я ничего не делаем

      if (this.users[userId] && this.users[userId].timeOut != null) {
        clearTimeout(this.users[userId].timeOut);
      }
      if (!this.users[userId]) {
        this.$set(this.users, userId, {
          online: false,
          typing: false,
          userName: userName,
          timeOut: null,
        });
      }
      this.users[userId].typing = true;
      this.users[userId].timeOut = setTimeout(() => {
        this.users[userId].typing = false;
      }, 2000);
    },
    onGetMessage: function(data) {
      if (parseInt(data.key) !== this.key) return;

      if (data.user_id == this.mainUser.userId) {
        this.messages.find((elem, index) => {
          if (this.messages.length - index <= 5) {
            if (elem.message == data.message) {
              elem.dateFull = fullDate(data.created_at);
              elem.created_at = dateFormatChat(data.created_at);
              elem.id = data.id;
            }
          }
        });
        return true;
      }

      //play sound
      if (this.newMessageSound) {
        try {
          this.newMessageSound.play();
        } catch {}
      }

      let message = {};
      message.dateFull = fullDate(data.created_at);
      message.created_at = dateFormatChat(data.created_at);
      message.message = data.message;
      message.id = data.id;
      message.photo = data.photo;
      message.username = data.username;
      message.role = data.role;
      message.key = data.order_id;
      message.user_id = data.user_id;
      message.is_deleted = 0;
      if (this.accessLevel == "admin") {
        message.is_admin_read = 0;
      }
      if (this.accessLevel == "user") {
        message.is_user_read = 0;
      }
      if (this.accessLevel == "booster") {
        message.is_booster_read = 0;
      }
      this.messages.push(message);
      setTimeout(() => {
        if (this.indexFirstUnreadMessage !== null) {
          this.unreadMessagesCountSeparator++;
        } else {
          this.unreadMessagesCountSeparator = 1;
        }
        if (this.windowActive && this.chatFull) {
          this.scrollToMessage(this.messages.length - 1);
        } else if (!this.windowActive && this.indexFirstUnreadMessage == null) {
          this.indexFirstUnreadMessage = this.messages.length - 1;
          this.scrollToMessage(this.indexFirstUnreadMessage);
        } else if (!this.chatFull && this.indexFirstUnreadMessage == null) {
          this.indexFirstUnreadMessage = this.messages.length - 1;
        } else {
          this.scrollToMessage(this.indexFirstUnreadMessage);
        }

        if (
          $(
            "#offer-" + this.key + " .open-offer-card-button .unreaded-messages"
          )
        ) {
          $(
            "#offer-" + this.key + " .open-offer-card-button .unreaded-messages"
          ).text(this.unreadMessagesCountSeparator);
          $(
            "#offer-" + this.key + " .open-offer-card-button .unreaded-messages"
          ).show();
        }
      }, 50);
    },
    openPinCodeModal: function() {
      document.getElementById("openPinCodeModal").click();
    },
    login: function() {
      document.getElementById("openLoginModal").click();
    },
    translate(source, message, params) {
      return translate(source, message, params);
    },
  },
};
</script>

<style lang="scss">
* {
  box-sizing: border-box;
}
.vue-chat {
  position: relative;
  width: 100%;
  height: 314px;
  font-family: "Exo 2";
  font-size: 14px;
  line-height: 1.3;
  color: #717070;
  background: #ffffff;
  transition: 0.5s;
  &--full {
    height: 560px;
  }
}
.messages {
  position: relative;
  padding-top: 16px;
}

.scroll-wrap {
  width: 100%;
  height: 458px;
}
.vb-content {
  position: relative;
}

.vb-dragger {
  z-index: 5;
  width: 4px;
  right: 12px;
}

.vb-dragger > .vb-dragger-styler {
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  -webkit-transform: rotate3d(0, 0, 0, 0);
  transform: rotate3d(0, 0, 0, 0);
  -webkit-transition: background-color 100ms ease-out, margin 100ms ease-out,
    height 100ms ease-out;
  transition: background-color 100ms ease-out, margin 100ms ease-out,
    height 100ms ease-out;
  margin: 5px 8px 5px 0;
  border-radius: 5px;
  width: 100%;
  height: calc(100% - 10px);
  display: block;
  cursor: pointer;
  background: #cdcdcf;
}
.chat-typing {
  margin-top: -25px;
  background: #ffffff;
  padding: 7px 23px;
  font-size: 12px;
  color: #717070;
  span + span {
    &:before {
      content: ", ";
    }
  }
  &:before {
    margin-right: 7px;
    margin-top: -2px;
    display: inline-block;
    vertical-align: middle;
    content: "";
    width: 20px;
    height: 6px;
    background: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iNiIgdmlld0JveD0iMCAwIDIwIDYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICA8Y2lyY2xlIG9wYWNpdHk9IjAuMiIgY3g9IjIiIGN5PSIzIiByPSIyIiBmaWxsPSIjQzRDNEM0Ii8+CiAgICA8Y2lyY2xlIG9wYWNpdHk9IjAuNiIgY3g9IjkiIGN5PSIzIiByPSIyIiBmaWxsPSIjQzRDNEM0Ii8+CiAgICA8Y2lyY2xlIGN4PSIxNyIgY3k9IjMiIHI9IjMiIGZpbGw9IiNDNEM0QzQiLz4KPC9zdmc+Cg==");
  }
}
.no-messages {
  position: relative;
  width: 264px;
  margin: 35px auto 0;
  padding-top: 100px;
  text-align: center;
  &:before {
    position: absolute;
    content: "";
    top: 0;
    left: 50%;
    margin-left: -43px;
    width: 86px;
    height: 86px;
    background: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iODYiIGhlaWdodD0iODYiIHZpZXdCb3g9IjAgMCA4NiA4NiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTgxLjcgMTcuMkg3My4xVjU1LjlIMTcuMlY2NC41QzE3LjIgNjYuODY1IDE5LjEzNSA2OC44IDIxLjUgNjguOEg2OC44TDg2IDg2VjIxLjVDODYgMTkuMTM1IDg0LjA2NSAxNy4yIDgxLjcgMTcuMlpNNjQuNSA0M1Y0LjNDNjQuNSAxLjkzNSA2Mi41NjUgMCA2MC4yIDBINC4zQzEuOTM1IDAgMCAxLjkzNSAwIDQuM1Y2NC41TDE3LjIgNDcuM0g2MC4yQzYyLjU2NSA0Ny4zIDY0LjUgNDUuMzY1IDY0LjUgNDNaIiBmaWxsPSIjRjFGMkY0Ii8+Cjwvc3ZnPgo=");
  }
  strong {
    position: relative;
    display: block;
    font-weight: 600;
    font-size: 14px;
    line-height: 17px;
    color: #161616;
  }
}

.chat-wrapper {
  position: relative;
  overflow: hidden;
  margin-bottom: 20px;
}
.open-chat {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 51px;
  background: #ffffff;
  color: #79c7dd;
  font-weight: bold;
  font-size: 14px;
  line-height: 51px;
  text-align: center;
  text-transform: uppercase;
  z-index: 9;
  cursor: pointer;
  &:before {
    position: absolute;
    height: 200px;
    bottom: 51px;
    left: 0;
    right: 0;
    content: "";
    background: linear-gradient(to top, #ffffff 0%, rgba(255, 255, 255, 0) 70%);
  }
}

.vue-chat--error {
  padding-top: 85px;
  padding-left: 50px;
  padding-right: 50px;
  text-align: center;
  color: #ffffff;
  font-size: 14px;
  background: #e2574c;
  &.vue-chat--need-auth {
    background: #4d306e;
  }
  &.vue-chat--full {
    .vue-chat-get-success {
      opacity: 1;
    }
  }
  strong {
    margin-bottom: 8px;
    display: block;
    font-weight: 600;
  }
  p {
    margin: 0;
  }
  .header {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    color: #ffffff;
    border-bottom: 1px solid rgba(255, 255, 255, 0.2);
    .icon-header {
      path {
        fill: #ffffff;
      }
      span {
        display: none;
      }
    }
  }
}
.icon-access-problem {
  margin-bottom: 20px;
  display: inline-block;
  width: 80px;
  height: 80px;
  background: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iODAiIGhlaWdodD0iODAiIHZpZXdCb3g9IjAgMCA4MCA4MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggb3BhY2l0eT0iMC4zIiBkPSJNNTYuNTc3OCAwSDIzLjQyMjJMMCAyMy40MjIyVjU2LjU3NzhMMjMuNDIyMiA4MEg1Ni41Nzc4TDgwIDU2LjU3NzhWMjMuNDIyMkw1Ni41Nzc4IDBaTTQwIDYzLjU1NTZDMzYuOCA2My41NTU2IDM0LjIyMjIgNjAuOTc3OCAzNC4yMjIyIDU3Ljc3NzhDMzQuMjIyMiA1NC41Nzc4IDM2LjggNTIgNDAgNTJDNDMuMiA1MiA0NS43Nzc4IDU0LjU3NzggNDUuNzc3OCA1Ny43Nzc4QzQ1Ljc3NzggNjAuOTc3OCA0My4yIDYzLjU1NTYgNDAgNjMuNTU1NlpNNDQuNDQ0NCA0NC40NDQ0SDM1LjU1NTZWMTcuNzc3OEg0NC40NDQ0VjQ0LjQ0NDRaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K");
}
.icon-need-auth {
  margin-bottom: 20px;
  display: inline-block;
  width: 74px;
  height: 74px;
  background: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNzQiIGhlaWdodD0iNzQiIHZpZXdCb3g9IjAgMCA3NCA3NCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggb3BhY2l0eT0iMC4zIiBkPSJNMzcgMEMxNi41NzYgMCAwIDE2LjU3NiAwIDM3QzAgNTcuNDI0IDE2LjU3NiA3NCAzNyA3NEM1Ny40MjQgNzQgNzQgNTcuNDI0IDc0IDM3Qzc0IDE2LjU3NiA1Ny40MjQgMCAzNyAwWk0zNyAxMS4xQzQzLjE0MiAxMS4xIDQ4LjEgMTYuMDU4IDQ4LjEgMjIuMkM0OC4xIDI4LjM0MiA0My4xNDIgMzMuMyAzNyAzMy4zQzMwLjg1OCAzMy4zIDI1LjkgMjguMzQyIDI1LjkgMjIuMkMyNS45IDE2LjA1OCAzMC44NTggMTEuMSAzNyAxMS4xWk0zNyA2My42NEMyNy43NSA2My42NCAxOS41NzMgNTguOTA0IDE0LjggNTEuNzI2QzE0LjkxMSA0NC4zNjMgMjkuNiA0MC4zMyAzNyA0MC4zM0M0NC4zNjMgNDAuMzMgNTkuMDg5IDQ0LjM2MyA1OS4yIDUxLjcyNkM1NC40MjcgNTguOTA0IDQ2LjI1IDYzLjY0IDM3IDYzLjY0WiIgZmlsbD0id2hpdGUiLz4KPC9zdmc+Cg==");
}
.vue-chat-get-success {
  position: absolute;
  bottom: 42px;
  left: 32px;
  right: 32px;
  height: 51px;
  font-weight: bold;
  text-align: center;
  opacity: 0;
  transition: 0.3s;
  a {
    padding: 0 25px;
    display: inline-block;
    line-height: 51px;
    color: #ffffff;
    text-decoration: none;
    text-transform: uppercase;
    font-size: 16px;
    transition: 0.3s;
    background: rgba(255, 255, 255, 0.1);
    cursor: pointer;
  }
}

.chat-error {
  position: absolute;
  left: 0;
  right: 0;
  padding: 8px;
  color: #e2574c;
  font-size: 12px;
  background: #ffffff;
  text-align: center;
  z-index: 10;
}
.chat-closed {
  position: relative;
  padding: 9px;
  background: #ffffff;
  font-size: 12px;
  color: rgba(#717070, 0.6);
  text-align: center;
  border-top: 1px solid #e1e1e2;
  strong {
    display: block;
    font-size: 15px;
    font-weight: 400;
    color: #717070;
  }
}
@media (max-width: 769px) {
  .chat-wrapper {
    margin-bottom: 0;
  }
}
</style>
